'use client'

import { FadeIn, FadeInStagger } from '@/components/ui/animation/faideIn'
import { buttonVariants, buttonVariantsPartner } from '@/components/ui/button'
import { ArrowIcon, SvgArrowUpRight, SvgLocation } from '@/components/ui/icons'
import { cn } from '@/lib/utils/helpers'
import { useAuth } from '@/lib/utils/providers/supabase/supabase-auth-provider'
import { useSupabase } from '@/lib/utils/providers/supabase/supabase-provider'
import {
  ArrowDownIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
} from '@heroicons/react/20/solid'
import moment from 'moment'
import Link from 'next/link'
import { useEffect, useRef, useState } from 'react'
import { useCookies } from 'react-cookie'
import { AiOutlineArrowRight } from 'react-icons/ai'
import { BsInfoCircleFill } from 'react-icons/bs'
import { FiArrowUpRight } from 'react-icons/fi'
import AiFurnance from './AiFurnance'
import CTAChat from './CTAChat'
import { Chat } from './Chat'
import DemoPdf from './DemoPdf'
import { COOKIE_NAME } from './config'
import './style.css'

import { getApplyRedirectUrl } from '@/lib/utils/functions'
import ReactPlayer from 'react-player'
import { useMediaQuery } from 'react-responsive'
import { Swiper, SwiperSlide } from 'swiper/react'

export function ChatPage({ theme }) {
  const { supabase } = useSupabase()
  const { isUserCookie, session } = useAuth()
  const [cookie, setCookie] = useCookies([COOKIE_NAME])
  const [isCookie, setIsCookie] = useState(theme || isUserCookie)
  const [isOpen, setIsOpen] = useState(true)
  const [cohorts, setCohorts] = useState(null)

  const isMobile = useMediaQuery({ maxWidth: 767 })
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 })
  const isDesktop = useMediaQuery({ minWidth: 992 })
  const swiperRef = useRef(null)
  const [activeIndex, setactiveIndex] = useState(0)

  const acceptCookies = () => {
    setIsOpen(false)
    const randomId = Math.random().toString(36).substring(7)
    setCookie(COOKIE_NAME, { randomId, codeRetrieved: false })
  }
  useEffect(() => {
    if (theme || isUserCookie) setIsCookie(true)
  }, [theme, isOpen, isUserCookie])
  useEffect(() => {
    getCohorts()
  }, [])
  const getCohorts = async () => {
    try {
      const { data, error } = await supabase
        .from('cohort')
        .select('*')
        .order('deadline', { ascending: true })

      if (error) {
        console.error('Error fetching cohorts:', error)
        setCohorts([])
      }
      setCohorts(data?.reverse() || [])
    } catch (error) {
      console.error('Unexpected error fetching cohorts:', error)

      setCohorts([])
    }
  }

  function formatDate(dateString) {
    const date = new Date(dateString + 'T09:00:00')

    const days = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ]
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ]

    // Get day name
    const dayName = days[date.getDay()]

    // Get day of the month
    const dayOfMonth = date.getDate()

    // Function to add ordinal suffix to day
    function getOrdinalSuffix(day) {
      if (day > 3 && day < 21) return 'th'
      switch (day % 10) {
        case 1:
          return 'st'
        case 2:
          return 'nd'
        case 3:
          return 'rd'
        default:
          return 'th'
      }
    }

    // Get month name
    const monthName = months[date.getMonth()]

    // Assemble the formatted date, the hour is fixed as 9am GST for the example
    return `${dayName} ${dayOfMonth}${getOrdinalSuffix(
      dayOfMonth,
    )} ${monthName} (9am GST)`
  }

  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <button
      onClick={() => {
        swiperRef?.current?.swiper?.slideNext()
      }}
      style={{ display: 'flex' }}
      className={
        activeIndex === cohorts?.length - 3 ? 'opacity-20' : 'opacity-100'
      }
      aria-disabled={currentSlide === slideCount - 1 ? true : false}
      type="button"
    >
      <ArrowRightIcon className="text-white w-[27px]" />
    </button>
  )
  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    <button
      onClick={() => {
        if (activeIndex !== 0) {
          swiperRef?.current?.swiper?.slidePrev()
        }
      }}
      className={
        'min-w-[54.22px] min-h-[36.15px] flex items-center justify-center bg-[#292B32] rounded-[6.77px] absolute top-[-70px] sm:top-[45px]  sm:left-[-80px] ' +
          activeIndex ===
        0
          ? 'opacity-20'
          : 'opacity-100'
      }
      style={{ display: 'flex' }}
      aria-disabled={currentSlide === 0 ? true : false}
      type="button"
    >
      <ArrowLeftIcon className="text-white w-[27px]" />
    </button>
  )
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: cohorts?.length > 2 ? 3 : cohorts?.length,
    slidesToScroll: cohorts?.length > 2 ? 3 : cohorts?.length,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: true,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 760,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }
  useEffect(() => {
    const adjustSlideHeight = () => {
      const slides = document.querySelectorAll('.swiper-slide-card')
      let maxHeight = 0

      slides.forEach((slide) => {
        const slideHeight = slide.offsetHeight
        if (slideHeight > maxHeight) {
          maxHeight = slideHeight
        }
      })

      slides.forEach((slide) => {
        slide.style.height = `${maxHeight}px`
      })
    }

    adjustSlideHeight()

    // Adjust heights again if the window is resized
    window.addEventListener('resize', adjustSlideHeight)

    // Clean up the event listener
    return () => window.removeEventListener('resize', adjustSlideHeight)
  }, [])

  return (
    <main className="flex flex-col align-center gap-4 pb-16 ">
      <main>
        <div className="relative isolate overflow-hidden">
          <svg
            className="absolute  inset-x-0  top-0 xl:left-32 -z-10 h-[50rem] w-full stroke-gray-800 [mask-image:radial-gradient(32rem_32rem_at_center,white,transparent)]"
            aria-hidden="true"
          >
            <defs>
              <pattern
                id="1f932ae7-37de-4c0a-a8b0-a6e3b4d44b84"
                width={200}
                height={200}
                x="50%"
                y={-1}
                patternUnits="userSpaceOnUse"
              >
                <path d="M.5 200V.5H200" fill="none" />
              </pattern>
            </defs>
            <svg x="50%" y={-1} className="overflow-visible fill-gray-800">
              <path
                d="M-200 0h201v201h-201Z M600 0h201v201h-201Z M-400 600h201v201h-201Z M200 800h201v201h-201Z"
                strokeWidth={0}
              />
            </svg>
            <rect
              width="100%"
              height="100%"
              strokeWidth={0}
              fill="url(#1f932ae7-37de-4c0a-a8b0-a6e3b4d44b84)"
            />
          </svg>
          <FadeIn>
            <div className=" mt-[-170px]">
              <div className="mx-auto  px-6 pb-10 pt-36 sm:pt-60 lg:px-8 lg:pt-32">
                <FadeIn>
                  <div className="flex justify-center mt-[120px]">
                    <div className=" flex  px-0.5 lg:w-[269px] h-8 pl-1 pr-2.5 py-1 bg-white bg-opacity-10 rounded-2xl border border-neutral-700 justify-start items-center gap-3 ">
                      <div
                        className="text-[14px]  leading-5 font-medium text-[#fff]
                   bg-white bg-opacity-10 py-0.5  flex cursor-default
                   lg:w-[150px] h-6 px-2.5   rounded-2xl justify-start items-center"
                      >
                        Start Your Journey!
                      </div>
                      <div className="flex flex-row items-center">
                        <div className="text-[14px] text-white text-sm font-medium cursor-pointer  leading-tight">
                          <Link href={`${getApplyRedirectUrl(session)}`}>
                            Apply Now
                          </Link>
                        </div>
                        <AiOutlineArrowRight className="text-[14px] leading-5 font-medium text-[#fff] mr-1" />
                      </div>
                    </div>
                  </div>
                </FadeIn>
                <div className="flex flex-col justify-center items-center">
                  <div className="mt-3">
                    <h1 className="text-[48px] sm:text-[72px] font-bold leading-[90px] text-center text-[#FFFFFF] text-7xl">
                      Reshape The Future
                    </h1>
                  </div>
                  <p
                    className="text-[#98A2B3] text-[20px] leading-[30px] font-normal text-center mt-8
              lg:w-[1039px]  text-xl "
                  >
                    Join AI Forge to access funding, resources, mentorship, and
                    a global network of AI enthusiasts. We're driving innovation
                    and empowering startups to develop solutions that transform
                    industries and foster sustainability.
                    <br />
                    <br />
                  </p>
                </div>
                <div>
                  <div className="mx-auto pl-0 sm:pl-0 max-w-[76rem] mt-12 apply  ">
                    <div className="sm:relative flex items-center justify-between gap-x-5 mt-4 mr-0">
                      <div
                        onClick={() => {
                          if (activeIndex !== 0) {
                            swiperRef?.current?.swiper?.slidePrev()
                          }
                        }}
                        className={`${
                          activeIndex === 0 ? 'opacity-20' : 'opacity-100'
                        } sm:absoluteee top-[-70px] sm:top-[85px] sm:left-[-80px] cursor-pointer min-w-[54.22px] min-h-[36.15px]	bg-white rounded-[6.77px] p-5.5 border border-solid border-gray-200 backdrop-blur-4 bg-opacity-90 flex justify-center items-center`}
                      >
                        <ArrowIcon
                          width="14"
                          height="14"
                          className="rotate-180"
                        />
                      </div>
                      <div
                        onClick={() => {
                          swiperRef?.current?.swiper?.slideNext()
                        }}
                        className={`${
                          activeIndex === cohorts?.length - 3
                            ? 'opacity-20'
                            : 'opacity-100'
                        } sm:absoluteee top-[-70px] sm:top-[85px] sm:right-[-80px] cursor-pointer min-w-[54.22px] min-h-[36.15px]	bg-white rounded-[6.77px] p-5.5 border border-solid border-gray-200 backdrop-blur-4 bg-opacity-90 flex justify-center items-center`}
                      >
                        <ArrowIcon
                          width="14"
                          height="14"
                          className="rotate-[-3deg]"
                        />
                      </div>
                      {/* <SlickArrowLeft />
                      <SlickArrowRight /> */}
                    </div>
                    <Swiper
                      ref={swiperRef}
                      onSlideChange={(e) => {
                        setactiveIndex(e.activeIndex)
                      }}
                      className="mt-8 sm:mt-8 flex overflow-hidden "
                      slidesPerView={
                        isMobile ? 1 : isTablet ? 2 : isDesktop ? 3 : 3
                      }
                      spaceBetween={10}
                      autoHeight={true}
                    >
                      {cohorts &&
                        cohorts.map((cohort, j) => {
                          return (
                            <SwiperSlide key={j} className="flex  h-full ">
                              <div
                                key={j}
                                className={`${
                                  isMobile
                                    ? 'w-full'
                                    : isTablet
                                    ? 'w-full'
                                    : isDesktop
                                    ? 'w-full'
                                    : 'w-full'
                                } grid grid-rows-1 p-[20px] gap-1 h-full border border-[#34383B] bg-[#0A0A0B] rounded-[12px]`}
                                style={{ display: 'grid' }}
                              >
                                <div className="flex items-center  gap-4 text-white text-[18px]">
                                  {cohort?.name}
                                  <div className="flex items-center gap-2 ">
                                    <div
                                      className={`w-[8px] h-[8px] rounded-full ${
                                        cohort?.is_active
                                          ? 'bg-[#19C735]'
                                          : 'bg-[#FFC700]'
                                      }`}
                                    ></div>
                                    <div
                                      className={`text-sm ${
                                        cohort?.is_active
                                          ? 'text-[#19C735]'
                                          : 'text-[#FFC700]'
                                      } `}
                                    >
                                      {cohort?.is_active ? 'Active' : 'Passed'}
                                    </div>
                                  </div>
                                </div>
                                <div className="text-[#B9C1CD] text-[14px] my-[6px] ">
                                  Application Deadline:{` `}
                                  {formatDate(cohort?.deadline)}
                                </div>
                                <div className="text-[#B4BBC8] text-[12px] flex gap-4 ">
                                  <div className="flex items-center gap-2 ">
                                    <SvgLocation stroke="#B4BBC8" />{' '}
                                    {cohort?.city || 'London'}
                                  </div>
                                  <div className="flex items-center gap-2 ">
                                    <svg
                                      width="16"
                                      height="17"
                                      viewBox="0 0 16 17"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M5.33325 3.98157C5.05992 3.98157 4.83325 3.7549 4.83325 3.48157V1.48157C4.83325 1.20823 5.05992 0.981567 5.33325 0.981567C5.60659 0.981567 5.83325 1.20823 5.83325 1.48157V3.48157C5.83325 3.7549 5.60659 3.98157 5.33325 3.98157Z"
                                        fill="#B4BBC8"
                                      />
                                      <path
                                        d="M10.6667 3.98157C10.3934 3.98157 10.1667 3.7549 10.1667 3.48157V1.48157C10.1667 1.20823 10.3934 0.981567 10.6667 0.981567C10.9401 0.981567 11.1667 1.20823 11.1667 1.48157V3.48157C11.1667 3.7549 10.9401 3.98157 10.6667 3.98157Z"
                                        fill="#B4BBC8"
                                      />
                                      <path
                                        d="M10 15.3149H6C2.25333 15.3149 1.5 13.5482 1.5 10.6949V6.58157C1.5 3.42157 2.56667 2.1349 5.30667 1.98157H10.6667C10.6733 1.98157 10.6867 1.98157 10.6933 1.98157C13.4333 2.1349 14.5 3.42157 14.5 6.58157V10.6949C14.5 13.5482 13.7467 15.3149 10 15.3149ZM5.33333 2.98157C3.46667 3.08823 2.5 3.6749 2.5 6.58157V10.6949C2.5 13.2482 2.98667 14.3149 6 14.3149H10C13.0133 14.3149 13.5 13.2482 13.5 10.6949V6.58157C13.5 3.68157 12.54 3.08823 10.6533 2.98157H5.33333Z"
                                        fill="#B4BBC8"
                                      />
                                      <path
                                        d="M13.8334 12.3816H2.16675C1.89341 12.3816 1.66675 12.1549 1.66675 11.8816C1.66675 11.6083 1.89341 11.3816 2.16675 11.3816H13.8334C14.1067 11.3816 14.3334 11.6083 14.3334 11.8816C14.3334 12.1549 14.1067 12.3816 13.8334 12.3816Z"
                                        fill="#B4BBC8"
                                      />
                                      <path
                                        d="M7.99992 5.64819C7.17992 5.64819 6.48658 6.09486 6.48658 6.96153C6.48658 7.37486 6.67992 7.68819 6.97325 7.88819C6.56659 8.12819 6.33325 8.51486 6.33325 8.96819C6.33325 9.79486 6.96659 10.3082 7.99992 10.3082C9.02659 10.3082 9.66658 9.79486 9.66658 8.96819C9.66658 8.51486 9.43325 8.12153 9.01992 7.88819C9.31992 7.68153 9.50659 7.37486 9.50659 6.96153C9.50659 6.09486 8.81992 5.64819 7.99992 5.64819ZM7.99992 7.54153C7.65325 7.54153 7.39992 7.33486 7.39992 7.00819C7.39992 6.67486 7.65325 6.48153 7.99992 6.48153C8.34659 6.48153 8.59992 6.67486 8.59992 7.00819C8.59992 7.33486 8.34659 7.54153 7.99992 7.54153ZM7.99992 9.48153C7.55992 9.48153 7.23992 9.26153 7.23992 8.86153C7.23992 8.46153 7.55992 8.24819 7.99992 8.24819C8.43992 8.24819 8.75992 8.46819 8.75992 8.86153C8.75992 9.26153 8.43992 9.48153 7.99992 9.48153Z"
                                        fill="#B4BBC8"
                                      />
                                    </svg>{' '}
                                    {moment(cohort?.end_date).format(
                                      'MMMM DD , YYYY',
                                    )}
                                  </div>
                                </div>
                              </div>
                            </SwiperSlide>
                          )
                        })}
                    </Swiper>
                  </div>
                </div>
                <FadeIn>
                  <div className="flex justify-center items-center gap-4 mt-12">
                    <Link
                      href={`${getApplyRedirectUrl(session)}`}
                      className={cn(
                        buttonVariantsPartner({
                          size: '2xl',
                          variant: 'secondary',
                        }),
                        'border-[#155EEF] bg-white/10',
                      )}
                    >
                      Apply Now
                      <FiArrowUpRight className="text-white text-xl md:text-2xl leading-7 ml-1 md:ml-3.5" />
                    </Link>
                    <FadeIn>
                      <Link
                        href={'/about'}
                        className={cn(
                          buttonVariants({ size: '2xl' }),
                          'max-sm:mx-auto leading-7 w-full text-sm sm:text-lg ',
                        )}
                      >
                        The Program
                        <SvgArrowUpRight className="sm:ml-3" />
                      </Link>
                    </FadeIn>
                  </div>
                </FadeIn>
              </div>
            </div>
          </FadeIn>
        </div>
        <FadeInStagger faster>
          <div className="relative isolate">
            <div className="flex justify-center mt-4 ">
              <a href="#team-mission" className="text-center w-12 h-12  ">
                <button className=" text-center flex items-center justify-center text-white w-12 h-12 hover:bg-blue-700 focus:outline-none focus:shadow-outline bg-blue-600 rounded-full button-arrow">
                  <ArrowDownIcon className="h-[27px]" />
                </button>
              </a>
            </div>
          </div>
        </FadeInStagger>
        <FadeInStagger className="px-6 sm:px-0" faster>
          <MentorMatchingCard />
        </FadeInStagger>
      </main>
      <FadeIn>
        <AiFurnance />
      </FadeIn>

      <FadeIn>
        <div className="flex flex-col mt-20 max-w-7xl mx-auto">
          <div className="relative">
            <div
              className="absolute inset-0 flex items-center"
              aria-hidden="true"
            >
              <div className="w-full border-t border-gray-300" />
            </div>
            <div className="relative flex justify-center">
              <span className="bg-black px-3 text-base font-semibold leading-6 text-gray-200">
                Support Materials
              </span>
            </div>
          </div>
        </div>
        <DemoPdf />
      </FadeIn>

      <section className="flex items-center flex-col gap-3 px-2 mt-20">
        {!isCookie && !isOpen && (
          <div className="lg:w-[629px] h-[52px] p-4 bg-zinc-900 bg-opacity-60 rounded-[10px] border border-zinc-900 justify-between items-start gap-3 inline-flex">
            <div className="flex gap-3">
              <BsInfoCircleFill className="w-5 h-5 relative text-gray-400" />
              <h1 className="text-gray-400 text-sm font-medium leading-tight">
                Please accept our cookie policy to continue!
              </h1>
            </div>
            <button
              className="h-5 justify-start items-center inline-flex text-blue-600 text-sm font-medium leading-tight gap-2"
              onClick={acceptCookies}
            >
              Accept Now <ArrowRightIcon className="h-5 w-5" />
            </button>
          </div>
        )}
        <div className="lg:w-1/2 overflow-x-auto pr-2">
          <Chat disabled={!isCookie} setIsCookie={setIsCookie} />
        </div>
      </section>
      <FadeIn>
        <CTAChat />
      </FadeIn>
    </main>
  )
}

const MentorMatchingCard = ({ bg, videoUrl, title }) => {
  return (
    <FadeIn className="relative w-full max-w-[76rem] mt-20 mx-auto overflow-hidden rounded-[16px] shadow-lg ">
      <div className="relative h-auto">
        <div
          style={{
            position: 'relative',
            paddingTop: '56.25%',
            borderRadius: 16,
          }}
        >
          <ReactPlayer
            width="100%"
            height="100%"
            controls={true}
            url={
              videoUrl ||
              'https://www.youtube.com/watch?v=Z8Cka749sbU&ab_channel=AIForge'
            }
            className="absolute left-0 top-0 w-full h-full object-cover "
            light={
              <img
                className="h-full object-cover"
                src={bg || '/images/home/applyBg.webp'}
                alt="Thumbnail"
              />
            }
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              borderRadius: 16,
            }}
            onClickPreview={() => {}}
            playIcon={
              <div
                className="absolute bottom-0 left-0 w-full p-4 sm:p-[45px] flex items-center justify-between text-white"
                style={{
                  background:
                    'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #1A1A1A 100%)',
                }}
              >
                <p className="textlg sm:text-[48px] font-[700]">
                  {title || 'Mentor Matching'}
                </p>
                <div>
                  <svg
                    className=" w-[35px] sm:w-auto "
                    width="68"
                    height="68"
                    viewBox="0 0 68 68"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="34"
                      cy="34"
                      r="33.4687"
                      fill="#D6D6D6"
                      fill-opacity="0.3"
                      stroke="white"
                      stroke-width="1.0625"
                    />
                    <path
                      d="M47.5533 32.6821C48.6072 33.2712 48.6072 34.7288 47.5533 35.3179L28.4283 46.0076C27.3401 46.6158 26.0312 45.8386 26.0312 44.6897L26.0313 23.3103C26.0313 22.1614 27.3401 21.3842 28.4283 21.9924L47.5533 32.6821Z"
                      stroke="white"
                      stroke-width="1.0625"
                    />
                  </svg>
                </div>
              </div>
            }
            playing={true}
          />
        </div>
      </div>
    </FadeIn>
  )
}
export default MentorMatchingCard
